import Vue from 'vue';
import VueRouter from 'vue-router';
// import dzp from '../pages/DZP';
// import getOneFree from '../pages/GetOneFree';
// import SignIn from '../pages/SignIn';
// import Subject from '../pages/Subject/Subject';
// import leaveMessage from '../pages/leaveMessage/leaveMessage';
// import shortMessage from '../pages/shortMessage/shortMessage';
// import mothersDayCoupon from '../pages/getCoupon/MothersDay';
// import redWine from '../pages/RedWine';
// import seckill from '../pages/Seckill';
// import QuanZhang from '../pages/QuanZhang';
// import HuanQing from '../pages/HuanQing';
// import ShengYan from '../pages/ShengYan';
// import XianLi from '../pages/XianLi';
// import AllWine from '../pages/AllWine';
// import MaoTai from '../pages/MaoTai';
// import blindBox from '../pages/blindBox';
// import tigerMachine from '../pages/tigerMachine';
// import jumpGame from '../pages/jumpGame';
// import reservation from '../pages/Reservation';
// import reservation0717 from '../pages/Reservation0717';
// import reservation0728 from '../pages/Reservation0728';
// import reservation0814 from '../pages/Reservation0814';
// import carShow from '../pages/carShow/carShow';
// import drawPage from '../pages/carShow/drawPage';
// import workerPage from '../pages/carShow/workerPage';
// import prizePage from '../pages/carShow/prizePage';
// import userAgreement from './appRouter'
// import reservation0823 from '../pages/Reservation0823';
// import reservation1009 from '../pages/Reservation1009';
// import carShow2 from '../pages/carShow2/carShow2';
// import vipEnjoy from '../pages/vipEnjoy/vipEnjoy';
// import buySend from '../pages/vipEnjoy/buySend';
// import subscriptionMember from '../pages/subscriptionMember/subscriptionMember';
// import equityDetail from '../pages/subscriptionMember/equityDetail';
// import agreement from '../pages/agreement';
// import paintingCoupon from '../pages/paintingCoupon';
// import proceteionCoupon from '../pages/proceteionCoupon';
// import coupon168 from '../pages/coupon168';
// import activityRouters from "@/router/activityRouter";
// import subjectCoupon from '../pages/subjectCoupon';
// import receiveCradCoupon from '../pages/receiveCradCoupon'
// import leaveMsgForCity from '../pages/leaveMsgForCity/leaveMsgForCity'
// import subjectRouters from './subjectRouter';
const dzp = () => import('../pages/DZP');
const getOneFree = () => import('../pages/GetOneFree');
const SignIn = () => import('../pages/SignIn');
const Subject = () => import('../pages/Subject/Subject');
const SubjectInternation = () => import('../pages/Subject/SubjectInternation');
const leaveMessage = () => import('../pages/leaveMessage/leaveMessage');
const anniversary = () => import('../pages/leaveMessage/anniversary');
const shortMessage = () => import('../pages/shortMessage/shortMessage');
const mothersDayCoupon = () => import('../pages/getCoupon/MothersDay');
const redWine = () => import('../pages/RedWine');
const seckill = () => import('../pages/Seckill');
const QuanZhang = () => import('../pages/QuanZhang');
const HuanQing = () => import('../pages/HuanQing');
const ShengYan = () => import('../pages/ShengYan');
const XianLi = () => import('../pages/XianLi');
const AllWine = () => import('../pages/AllWine');
const MaoTai = () => import('../pages/MaoTai');
const blindBox = () => import('../pages/blindBox');
const zeekrBlindBox = () => import('../pages/zeekrBlindBox');
const tigerMachine = () => import('../pages/tigerMachine');
const jumpGame = () => import('../pages/jumpGame');
const reservation = () => import('../pages/Reservation');
const reservation0717 = () => import('../pages/Reservation0717');
const reservation0728 = () => import('../pages/Reservation0728');
const reservation0814 = () => import('../pages/Reservation0814');
const carShow = () => import('../pages/carShow/carShow');
const drawPage = () => import('../pages/carShow/drawPage');
const workerPage = () => import('../pages/carShow/workerPage');
const prizePage = () => import('../pages/carShow/prizePage');
import userAgreement from './appRouter'
const reservation0823 = () => import('../pages/Reservation0823');
const reservation1009 = () => import('../pages/Reservation1009');
const carShow2 = () => import('../pages/carShow2/carShow2');
const vipEnjoy = () => import('../pages/vipEnjoy/vipEnjoy');
const buySend = () => import('../pages/vipEnjoy/buySend');
const subscriptionMember = () => import('../pages/subscriptionMember/subscriptionMember');
const equityDetail = () => import('../pages/subscriptionMember/equityDetail');
const agreement = () => import('../pages/agreement');
const paintingCoupon = () => import('../pages/paintingCoupon');
const proceteionCoupon = () => import('../pages/proceteionCoupon');
const coupon168 = () => import('../pages/coupon168');
import activityRouters from "@/router/activityRouter";
const subjectCoupon = () => import('../pages/subjectCoupon');
const receiveCradCoupon = () => import('../pages/receiveCradCoupon');
const leaveMsgForCity = () => import('../pages/leaveMsgForCity/leaveMsgForCity');
const springFestivalSpecialPage = () => import("../pages/Subject/springFestivalSpecialPage");
const PaintSubject240124 = () => import('../pages/Subject/PaintSubject240124');
const memberSpecialPage = () => import("../pages/Subject/memberSpecialPage");
const eSignPage = () => import("../pages/eSignPage/eSignPage");
const showSpecial = () => import('../pages/showSpecial.vue')
const reservation0301 = () => import('../pages/Reservation0301')
const coffee = () => import('../pages/Subject/coffee.vue')
const mxUseCar = () => import('../pages/Subject/mxUseCar.vue')
const hainanTravel = () => import('../pages/travel/hainanTravel.vue')

const payment = () => import('../pages/payment.vue')
const newCarDepositPayment = () => import('../pages/newCarDepositPayment.vue')
const paySuccess = () => import('../pages/paySuccess.vue')
const autoShow = () => import('../pages/autoShow/autoShow.vue')
const workerPage2 = () => import('../pages/autoShow/workerPage.vue');
const drawPage2 = () => import('../pages/autoShow/drawPage.vue');
const drawPhone = () => import('../pages/autoShow/drawPhone.vue');
const anniversaryPage = () => import('../pages/activity/anniversaryPage.vue')
const anniversarySeckill = () => import('../pages/activity/anniversarySeckill.vue')
const memberUniverPage = () => import('../pages/Subject/memberUniverPage');
const buyCar = () => import('../pages/buyCar.vue');
const wash = () => import('../pages/wash/wash.vue');
const washGoodsDetails = () => import('../pages/wash/washGoodsDetails.vue');
const washGoodsList = () => import('../pages/wash/washGoodsList.vue');
const washStoreList = () => import('../pages/wash/washStoreList.vue');
const anniversaryNew = () => import('../pages/leaveMessage/anniversaryNew');
const anniversaryLexus = () => import('../pages/leaveMessage/anniversaryLexus');


const myCar = () => import('../pages/myCar/myCar.vue');
const addCar = () => import('../pages/myCar/addMyCar.vue');
const addCarModel = () => import('../pages/myCar/addCarModel.vue');
const addCarSeries = () => import('../pages/myCar/addCarSeries.vue');
const carInformation = () => import('../pages/myCar/carInformation.vue');
const lottery = () => import('../pages/lottery/lottery');
const show = () => import('../pages/lottery/show');
const aboutUs = () => import('../pages/mySetting/aboutUs.vue')
const personalPreferences = () => import('../pages/mySetting/personalPreferences.vue')
const equityGoodsPreview = () => import('../pages/euqity/equityGoodsPreview.vue')
const coffeeNestle = () => import('../pages/Subject/coffeeNestle.vue')
const keepFunds = () => import('../pages/keepfunds/keepFunds.vue')
const wewXCofficialAccount = () => import('../pages/wewXCofficialAccount/wewXCofficialAccount.vue')
const wewXCofficialAccountNew = () => import('../pages/wewXCofficialAccount/wewXCofficialAccountNew.vue')
const wewXCofficialAccountLexus = () => import('../pages/wewXCofficialAccount/wewXCofficialAccountLexus.vue')
const brandSubject = () => import('../pages/Subject/brandSubject.vue')
const aito = () => import('../pages/aito/aito');
const aitoSubmit = () => import('../pages/aito/aitoSubmit');
const aitoResult = () => import('../pages/aito/aitoResult');
const aitoShow = () => import('../pages/aito/aitoShow');
const permissionPage = () => import('../pages/permissionPage');



const transferIntroductionIndex = () => import('../pages/transferIntroductionLeaveMessage/transferIntroductionIndex.vue')
const staffTransferIntroductionIndex = () => import('../pages/transferIntroductionLeaveMessage/staffTransferIntroductionIndex.vue')
const transferIntroductionLeaveVehicleModel = () => import('../pages/transferIntroductionLeaveMessage/transferIntroductionLeaveVehicleModel.vue')
const transferIntroductionLeaveSubmit = () => import('../pages/transferIntroductionLeaveMessage/transferIntroductionLeaveSubmit.vue')
const washBeautyCardRights = () => import('../pages/wash/washBeautyCardRights.vue')
const privilegePurchaseRights = () => import('../pages/wash/privilegePurchaseRights.vue')

const landian = () => import('../pages/landian/landian.vue');
const landianSubmit = () => import('../pages/landian/landianSubmit.vue');
const landianResult = () => import('../pages/landian/landianResult.vue');
const aboutZs = () => import('../pages/aboutZs/aboutZs.vue');
const qualifications = () => import('../pages/aboutZs/qualifications.vue');
const zsUserAgreement = () => import('../pages/aboutZs/zsUserAgreement.vue');
const memberUserAgreement = () => import('../pages/aboutZs/memberUserAgreement.vue');
const privacyAgreement = () => import('../pages/aboutZs/privacyAgreement.vue');
const zjsCouponUse = () => import('../pages/zjsCouponUse');
const enterpriseMicroCollection = () => import('../pages/enterpriseMicroCollection');
const questionnaire = () => import('../pages/questionnaire/questionnaire');
const questionnaireList = () => import('../pages/questionnaire/questionnaireList');
const officialAccountCoupon = () => import('../pages/coupon/officialAccountCoupon');
const couponCenter = () => import('../pages/couponCenter/index');
const agreementDetails = () => import('../pages/agreementDetails');
const dyIntentionMoneyCollection = () => import('../pages/Subject/dyIntentionMoneyCollection');
const newEnergyHome = () => import('../pages/newEnergy/newEnergyHome');
const newEnergy = () => import('../pages/newEnergy/newEnergy');
const pinganUserAgreement = () => import('../pages/pingan/UserAgreement.vue');
const pinganPrivacyPolicy = () => import('../pages/pingan/PrivacyPolicy.vue');

import subjectRouters from './subjectRouter';


Vue.use(VueRouter);

const routes = [
  {
    path: '/DZP',
    name: 'DZP',
    component: dzp,
  },
  {
    path: '/GetOneFree',
    name: 'GetOneFree',
    component: getOneFree,
  },
  {
    path: '/SignIn',
    name: 'SignIn',
    component: SignIn,
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
  },
  {
    path: '/Subject',
    name: 'Subject',
    component: Subject,
  },
  {
    path: '/SubjectInternation',
    name: '',
    component: SubjectInternation,
  },
  {
    path: '/leaveMessage',
    name: 'leaveMessage',
    component: leaveMessage,
  },
  {
    path: '/anniversary',
    name: 'anniversary',
    component: anniversary,
  },
  {
    path: '/anniversaryNew',
    name: 'anniversaryNew',
    component: anniversaryNew,
  },
  {
    path: '/anniversaryLexus',
    name: 'anniversaryLexus',
    component: anniversaryLexus,
  },
  {
    path: '/shortMessage',
    name: 'shortMessage',
    component: shortMessage,
  },
  {
    path: '/mothersDayCoupon',
    name: 'mothersDayCoupon',
    component: mothersDayCoupon,
  },
  {
    path: '/RedWine',
    name: 'RedWine',
    component: redWine,
  },
  {
    path: '/Seckill',
    name: 'Seckill',
    component: seckill,
  },
  {
    path: '/QuanZhang',
    name: 'QuanZhang',
    component: QuanZhang,
  },
  {
    path: '/HuanQing',
    name: 'HuanQing',
    component: HuanQing,
  },
  {
    path: '/ShengYan',
    name: 'ShengYan',
    component: ShengYan,
  },
  {
    path: '/XianLi',
    name: 'XianLi',
    component: XianLi,
  },
  {
    path: '/AllWine',
    name: 'AllWine',
    component: AllWine,
  },
  {
    path: '/MaoTai',
    name: 'MaoTai',
    component: MaoTai,
  },
  {
    path: '/blindBox',
    name: 'blindBox',
    component: blindBox,
  },
  {
    path: '/zeekrBlindBox',
    name: 'zeekrBlindBox',
    component: zeekrBlindBox,
  },
  {
    path: '/tigerMachine',
    name: 'tigerMachine',
    component: tigerMachine,
  },
  {
    path: '/jumpGame',
    name: 'jumpGame',
    component: jumpGame,
  },
  {
    path: '/Reservation',
    name: 'Reservation',
    component: reservation,
  },
  {
    path: '/Reservation0717',
    name: 'Reservation0717',
    component: reservation0717,
  },
  {
    path: '/Reservation0728',
    name: 'Reservation0728',
    component: reservation0728,
  },
  {
    path: '/Reservation0814',
    name: 'Reservation0814',
    component: reservation0814,
  },
  {
    path: '/Reservation0823',
    name: 'Reservation0823',
    component: reservation0301,
  },
  {
    path: '/Reservation1009',
    name: 'Reservation1009',
    component: reservation1009,
  },
  {
    path: '/carShow',
    name: 'autoShow',
    component: autoShow,
  },
  {
    path: '/drawPage',
    name: 'drawPage',
    component: drawPage,
  },
  {
    path: '/workerPage',
    name: 'workerPage2',
    component: workerPage2,
  },
  {
    path: '/prizePage',
    name: 'prizePage',
    component: prizePage,
  },
  {
    path: '/carShow2',
    name: 'carShow2',
    component: carShow2,
  },
  {
    path: '/vipEnjoy',
    name: 'vipEnjoy',
    component: vipEnjoy,
  },
  {
    path: '/buySend',
    name: 'buySend',
    component: buySend,
  },
  {
    path: '/subscriptionMember',
    name: 'subscriptionMember',
    component: subscriptionMember,
  },
  {
    path: '/equityDetail',
    name: 'equityDetail',
    component: equityDetail,
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: agreement,
  },
  {
    path: '/paintingCoupon',
    name: 'paintingCoupon',
    component: paintingCoupon,
  },
  {
    path: '/proceteionCoupon',
    name: 'proceteionCoupon',
    component: proceteionCoupon,
  },
  {
    path: '/coupon168',
    name: 'coupon168',
    component: coupon168,
  },
  {
    path: '/subjectCoupon',
    name: 'subjectCoupon',
    component: subjectCoupon,
  },
  {
    path: '/receiveCradCoupon',
    name: 'receiveCradCoupon',
    component: receiveCradCoupon,
  },
  {
    path: '/wash',
    name: 'wash',
    component: wash,
  },
  {
    path: '/washGoodsDetails',
    name: 'washGoodsDetails',
    component: washGoodsDetails,
  },
  {
    path: '/washGoodsList',
    name: 'washGoodsList',
    component: washGoodsList,
  },
  {
    path: '/washStoreList',
    name: 'washStoreList',
    component: washStoreList,
  },
  {
    path: '/leaveMsgForCity',
    name: 'leaveMsgForCity',
    component: leaveMsgForCity,
  },
  {
    path: '/springFestivalSpecialPage',
    name: 'springFestivalSpecialPage',
    component: springFestivalSpecialPage,
  },
  {
    path: '/paintSubject240124',
    name: 'PaintSubject240124',
    component: PaintSubject240124,
  },
  {
    path: '/eSignPage',
    name: 'eSignPage',
    component: eSignPage,
  },
  {
    path: '/memberSpecialPage',
    name: 'memberSpecialPage',
    component: memberSpecialPage,
  },
  {
    path: '/showSpecial',
    name: 'showSpecial',
    component: showSpecial,
  },
  {
    path: '/Reservation0301',
    name: 'Reservation0301',
    component: reservation0301,
  },
  {
    path: '/Subject/coffee',
    name: 'coffee',
    component: coffee,
  },
  {
    path: '/Subject/mxUseCar',
    name: 'mxUseCar',
    component: mxUseCar,
  },
  {
    path:'/hainanTravel',
    name: 'hainanTravel',
    component: hainanTravel,
  },
  {
    path:'/payment',
    name: 'payment',
    component: payment,
  },
  {
    path:'/newCarDepositPayment',
    name: 'newCarDepositPayment',
    component: newCarDepositPayment,
  },
  {
    path:'/paySuccess',
    name: 'paySuccess',
    component: paySuccess,
  },
  {
    path:'/carShow/autoShow',
    name: 'autoShow',
    component: autoShow,
  },
  {
    path:'/drawPage2',
    name: 'drawPage2',
    component: drawPage2,
  },
  {
    path:'/drawPhone',
    name: 'drawPhone',
    component: drawPhone,
  },
  {
    path: '/anniversaryPage',
    name: 'anniversaryPage',
    component: anniversaryPage,
  },
  {
    path: '/anniversarySeckill',
    name: 'anniversarySeckill',
    component: anniversarySeckill,
  },
  {
    path: '/memberUniverPage',
    name: 'memberUniverPage',
    component: memberUniverPage,
  },

  {
    path:'/buyCar',
    name: 'buyCar',
    component: buyCar,
  },
  {
    path:'/lottery',
    name: 'lottery',
    component: lottery,
  },
  {
    path:'/lottery/show',
    name: 'show',
    component: show,
  },

  {
    path: '/myCar',
    name: 'myCar',
    component: myCar,
  },
  {
    path: '/addCar',
    name: 'addCar',
    component: addCar,
  },
  {
    path: '/addCarSeries',
    name: 'addCarSeries',
    component: addCarSeries,
  },
  {
    path: '/addCarModel',
    name: 'addCarModel',
    component: addCarModel,
  },
  {
    path: '/carInformation',
    name: 'carInformation',
    component: carInformation,
  },
  {
    path: '/aboutUs',
    name: 'aboutUs',
    component: aboutUs
  },
  {
    path: '/personalPreferences',
    name: 'personalPreferences',
    component: personalPreferences
  },
  {
    path: '/equityGoodsPreview',
    name: 'equityGoodsPreview',
    component: equityGoodsPreview
  },
  {
    path: '/keepFunds',
    name: 'keepFunds',
    component: keepFunds
  },
  {
    path: '/wewXCofficialAccount',
    name: 'wewXCofficialAccount',
    component: wewXCofficialAccount
  },
  {
    path: '/wewXCofficialAccountNew',
    name: 'wewXCofficialAccountNew',
    component: wewXCofficialAccountNew
  },
  {
    path: '/wewXCofficialAccountLexus',
    name: 'wewXCofficialAccountLexus',
    component: wewXCofficialAccountLexus
  },
  {
    path: '/Subject/coffeeNestle',
    name: 'coffeeNestle',
    component: coffeeNestle,
  },
  {
    path: '/brandSubject',
    name: 'brandSubject',
    component: brandSubject,
  },
  {
    path: '/dyIntentionMoneyCollection',
    name: 'dyIntentionMoneyCollection',
    component: dyIntentionMoneyCollection,
  },
  {
    path: '/aito',
    name: 'aito',
    component: aito,
  },
  {
    path: '/aitoSubmit',
    name: 'aitoSubmit',
    component: aitoSubmit,
  },
  {
    path: '/aitoResult',
    name: 'aitoResult',
    component: aitoResult,
  },
  {
    path: '/aitoShow',
    name: 'aitoShow',
    component: aitoShow,
  },
  {
    path: '/permissionPage',
    name: 'permissionPage',
    component: permissionPage,
  },
  {
    path: '/zjsLeaveMessage/transferIntroductionIndex',
    name: 'transferIntroductionIndex',
    component: transferIntroductionIndex,
  },
  {
    path: '/zjsLeaveMessage/staffTransferIntroductionIndex',
    name: 'staffTransferIntroductionIndex',
    component: staffTransferIntroductionIndex,
  },
  {
    path: '/zjsLeaveMessage/transferIntroductionLeaveVehicleModel',
    name: 'transferIntroductionLeaveVehicleModel',
    component: transferIntroductionLeaveVehicleModel,
  },
  {
    path: '/zjsLeaveMessage/transferIntroductionLeaveSubmit',
    name: 'transferIntroductionLeaveSubmit',
    component: transferIntroductionLeaveSubmit,
  },
  {
    path: '/washBeautyCardRights',
    name: 'washBeautyCardRights',
    component: washBeautyCardRights,
  },
  {
    path: '/privilegePurchaseRights',
    name: 'privilegePurchaseRights',
    component: privilegePurchaseRights,
  },

  {
    path: '/landian',
    name: 'landian',
    component: landian,
  },
  {
    path: '/landianSubmit',
    name: 'landianSubmit',
    component: landianSubmit,
  },
  {
    path: '/landianResult',
    name: 'landianResult',
    component: landianResult,
  },
  {
    path: '/aboutZs',
    name: 'aboutZs',
    component: aboutZs,
  },
  {
    path: '/qualifications',
    name: 'qualifications',
    component: qualifications,
  },
  {
    path: '/zsUserAgreement',
    name: 'zsUserAgreement',
    component: zsUserAgreement,
  },
  {
    path: '/memberUserAgreement',
    name: 'memberUserAgreement',
    component: memberUserAgreement,
  },
  {
    path: '/privacyAgreement',
    name: 'privacyAgreement',
    component: privacyAgreement,
  },
  {
    path: '/zjsCouponUse',
    name: 'zjsCouponUse',
    component: zjsCouponUse,
  },
  {
    path: '/enterpriseMicroCollection',
    name: 'enterpriseMicroCollection',
    component: enterpriseMicroCollection,
  },
  {
    path: '/questionnaire',
    name: 'questionnaire',
    component: questionnaire,
  },
  {
    path: '/questionnaireList',
    name: 'questionnaireList',
    component: questionnaireList,
  },
  {
    path: '/officialAccountCoupon',
    name: 'officialAccountCoupon',
    component: officialAccountCoupon,
  },
  {
    path: '/couponCenter',
    name: 'couponCenter',
    component: couponCenter,
  },
  {
    path: '/agreementDetails',
    name: 'agreementDetails',
    component: agreementDetails,
  },
  {
    path: '/newEnergyHome',
    name: 'newEnergyHome',
    component: newEnergyHome,
  },
  {
    path: '/newEnergy',
    name: 'newEnergy',
    component: newEnergy,
  },
  {
    path: '/pinganUserAgreement',
    name: 'pinganUserAgreement',
    component: pinganUserAgreement,
  },
  {
    path: '/pinganPrivacyPolicy',
    name: 'pinganPrivacyPolicy',
    component: pinganPrivacyPolicy,
  },

  ...subjectRouters,
  ...userAgreement,
  ...activityRouters,

];

const router = new VueRouter({
  mode: 'hash',
  base: '/h5/',
  routes,
  scrollBehavior: () => ({ y: 0 }),
});

export default router;
